export { default } from './Content.component';
